<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display: flex;justify-content: space-between">
        <div class="btn-box">
          <el-date-picker
            v-model="timeValue"
            type="daterange"
            :picker-options="pickerOptions2"
            size="small"
            unlink-panels
            @change="changeTimeValue"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
        <!--<input-select selectTitle="缴费状态" :selectKey="'payStatus'" :selectData="payStatusList" @search="search" style="margin-left: 10px;"/>-->
        <!--<input-select selectTitle="缴费方式" :selectKey="'payChannel'" :selectData="payChannelList" @search="search"/>-->
      </div>
      <div style="display: flex;justify-content: space-between;">
        <input-search placeholder="付款人" @search="searchKey" />
      </div>
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :hasOperation="false" />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/activity";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "activity-consumption-record",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧活动",
          name: "activity-manage"
        },
        {
          value: "缴费记录"
        }
      ],
      timeValue: [],
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() > new Date((new Date() / 1000 + 86400) * 1000);
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      exportUrl: "",
      payStatusList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: "1",
          label: "未缴费"
        },
        {
          key: "2",
          label: "已缴费"
        }
      ],
      payChannelList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: "1",
          label: "微信"
        },
        {
          key: "2",
          label: "其他"
        }
      ],
      tableHead: [
        {
          prop: "personName",
          label: "付款人"
        },
        {
          prop: "personPhone",
          label: "付款人手机"
        },
        {
          prop: "enterpriseName",
          label: "所属企业"
        },
        {
          prop: "money",
          label: "金额"
        },
        {
          prop: "statusText",
          label: "缴费状态"
        },
        {
          prop: "consumeTime",
          label: "付款时间"
        }
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      requestData: {
        searchKey: ""
      }
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getCreatTime();
  },
  activated() {
    this.getPage()
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportRepairPayRecord}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${
        this.requestData.searchKey
      }&payStatus=${this.requestData.payStatus}`;
    },
    getCreatTime() {
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      // let hour = nowDate.getHours() < 10 ? '0' + nowDate.getHours() : nowDate.getHours()
      // let minute = nowDate.getMinutes() < 10 ? '0' + nowDate.getMinutes() : nowDate.getMinutes()
      // let second = nowDate.getSeconds() < 10 ? '0' + nowDate.getSeconds() : nowDate.getSeconds()
      this.timeValue[0] = year + "-" + month + "-01";
      this.timeValue[1] = year + "-" + month + "-" + date;
      this.getPage();
    },
    changeTimeValue() {
      this.pageNum = 1;
      this.pageSize = 10;
      this.getPage();
    },
    getPage() {
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      if (this.timeValue && this.timeValue.length > 0) {
        reqData.startTime = `${this.timeValue[0]} 00:00:00`;
        reqData.endTime = `${this.timeValue[1]} 23:59:59`;
      } else {
        reqData.startTime = "";
        reqData.endTime = "";
      }
      this.$axios
        .post(api.getConsumptionRecordPage, reqData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map(v => {
              if (v.payWay === "1") {
                v.payWayText = "支付宝";
              } else if (v.payWay === "2") {
                v.payWayText = "微信";
              } else if (v.payWay === "3") {
                v.payWayText = "银行转账";
              } else if (v.payWay === "4") {
                v.payWayText = "线下缴费";
              }
              if (v.payTime) {
                v.payTime = v.payTime.slice(0, 19);
              }

              if (v.status === "0") {
                v.statusText = "待支付";
              } else if (v.status === "1") {
                v.statusText = "支付成功";
              } else if (v.status === "2") {
                v.statusText = "支付失败";
              } else if (v.status === "3") {
                v.statusText = "等待退款";
              } else if (v.status === "4") {
                v.statusText = "退款成功";
              } else if (v.status === "5") {
                v.statusText = "退款失败";
              }
            });
            this.total = res.data.data.total;
            this.tableData = data;
          }
        })
        .catch(errorHandler("获取信息失败"));
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/Activity/ConsumptionRecord/ActivityConsumptionRecord.vue